import React from "react";
import { Instagram, Twitter, Facebook, Mail } from "lucide-react";

export const Footer = ({ onNavigate }) => {
  return (
    <footer className="relative z-10 border-t border-primary/10 bg-background/80 backdrop-blur-sm mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="text-2xl text-street tracking-[0.3em] mb-3">TIKA</h3>
            <p className="text-sm text-muted-foreground max-w-md">
              Votre plateforme de billetterie pour les événements culturels Hip Hop, Afrobeat et RNB. 
              Célébrons ensemble notre culture.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-3">Liens rapides</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <button
                  onClick={() => onNavigate && onNavigate("home")}
                  className="hover:text-primary transition-colors"
                >
                  Événements
                </button>
              </li>
              <li>
                <button
                  onClick={() => onNavigate && onNavigate("culture")}
                  className="hover:text-primary transition-colors"
                >
                  Culture
                </button>
              </li>
              <li>
                <button
                  onClick={() => onNavigate && onNavigate("about")}
                  className="hover:text-primary transition-colors"
                >
                  À propos de nous
                </button>
              </li>
              <li>
                <button
                  onClick={() => onNavigate && onNavigate("contact")}
                  className="hover:text-primary transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-semibold mb-3">Informations légales</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <button
                  onClick={() => onNavigate && onNavigate("cgv")}
                  className="hover:text-primary transition-colors"
                >
                  CGV
                </button>
              </li>
              <li>
                <button
                  onClick={() => onNavigate && onNavigate("cgu")}
                  className="hover:text-primary transition-colors"
                >
                  CGU
                </button>
              </li>
              <li>
                <button
                  onClick={() => onNavigate && onNavigate("privacy")}
                  className="hover:text-primary transition-colors"
                >
                  Politique de confidentialité
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Social Links */}
        <div className="mb-8">
          <h4 className="font-semibold mb-3">Suivez-nous</h4>
          <div className="flex gap-3">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-lg bg-muted/30 hover:bg-primary/20 flex items-center justify-center transition-colors"
              aria-label="Instagram"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-lg bg-muted/30 hover:bg-primary/20 flex items-center justify-center transition-colors"
              aria-label="Twitter"
            >
              <Twitter className="w-5 h-5" />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-lg bg-muted/30 hover:bg-primary/20 flex items-center justify-center transition-colors"
              aria-label="Facebook"
            >
              <Facebook className="w-5 h-5" />
            </a>
            <a
              href="mailto:contact@tika.fr"
              className="w-10 h-10 rounded-lg bg-muted/30 hover:bg-primary/20 flex items-center justify-center transition-colors"
              aria-label="Email"
            >
              <Mail className="w-5 h-5" />
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-border text-center text-sm text-muted-foreground">
          <p>© 2025 TIKA. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};
